import { render } from "./index.vue?vue&type=template&id=6fe11a88&scoped=true&bindings={\"bg1\":\"data\",\"img\":\"data\",\"list1\":\"data\",\"list2\":\"data\",\"list3\":\"data\",\"list4\":\"data\",\"sendId\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6fe11a88&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6fe11a88"

export default script